import './App.css';
import './Pages/css/main.css'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Header from './Pages/nav/header';
import Footer from './Pages/nav/footer';
import Sidebar from './Pages/nav/sidebar';

import UrlCreate from './Pages/urlCreate';
import UrlPayment from './Pages/urlPayment';
import UrlComplete from './Pages/urlComplete';
import UrlDetail from './Pages/urlDetail';
import UrlUserHistory from './Pages/urlUserHistory';
import UrlNotice from './Pages/urlNotice';

import ErrorBoundary from './Pages/common/ErrorBoundary'
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { change_hostLogoImg } from './store';

import ScrollToTop from './ScrollToTop';

function App() {
  console.error = (message) => { };

  let location = useLocation();
  let dispatch = useDispatch();

  useEffect(() => {
    if (window.location.hostname == "cp.onu-terminal.com") {
      dispatch(change_hostLogoImg("onu"))
    }
    else {
      dispatch(change_hostLogoImg("fast"))
    }
  }, [])

  return (
    <div className="App" style={{ maxWidth: "800px", margin: "0 auto" }}>
      <ScrollToTop behavior="auto" />
      <div className="py-0 md:py-5 header">
        <Header />
        <div className={`section2`}>
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<UrlCreate />} />
              <Route path="/urlPayment" element={<UrlPayment />} />
              <Route path="/urlComplete" element={<UrlComplete />} />
              <Route path="/urlDetail" element={<UrlDetail />} />
              <Route path="/urlUserHistory" element={<UrlUserHistory />} />
              <Route path="/urlNotice" element={<UrlNotice />} />


              {/* <Route path="/createMerchant" element={<CreateMerchant />} /> */}

              {JSON.parse(localStorage.getItem("userId"))?.sugi_expose == "Y"
                ?
                <Route path="*" element={<Navigate to="/dashboard" />} />
                :
                <Route path="*" element={<Navigate to="/paylist" />} />
              }
            </Routes>
          </ErrorBoundary>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
